import { CART_CREATE_RESET, CART_EMPTY } from '../constants/cartConstants';
import { ID_RESET } from '../constants/idConstants';
import { isOlderThan30Minutes } from './date-helper';
import { notifyInfo } from './Notify';
import { posthogOrderCaptureEvent, posthogOrderGroupEvent } from '../posthog/orderEvent';
import {
  POSTHOG_CAPTURE_ORDER_EXPIRED, POSTHOG_GROUP_ORDER, POSTHOG_ORDER_EXPIRED_STATUS,
} from '../posthog/constants';

function dispatchReset(dispatch) {
  dispatch({ type: CART_EMPTY });
  dispatch({ type: ID_RESET });
  dispatch({ type: CART_CREATE_RESET });
}

function resetCartItemLocale() {
  localStorage.setItem('isCheckStore', 'true');
  localStorage.removeItem('isCheckStoreAlreadyAsk');
}

export function resetCartNavigation(dispatch) {
  dispatchReset(dispatch);
  resetCartItemLocale();
}

export const checkStateCartItems = (cartItems, navigate, dispatch, redirectPath = '/home') => {
  if (!cartItems) {
    resetCartNavigation(dispatch);
    navigate('/home');
  }

  if (cartItems?.createdAt && isOlderThan30Minutes(cartItems?.createdAt)) {
    posthogOrderCaptureEvent(cartItems, POSTHOG_CAPTURE_ORDER_EXPIRED);
    posthogOrderGroupEvent(POSTHOG_GROUP_ORDER, POSTHOG_ORDER_EXPIRED_STATUS, cartItems);
    resetCartNavigation(dispatch);
    if (redirectPath === '/home') notifyInfo('Ta session a expiré !');
    navigate(redirectPath);
  }
};
